/**
 * Identity-only claims always present on tokens issued by the Auth0 PostLogin Action.
 * Authorization data (roles, orgId, modules, restrictions) is resolved server-side per request
 * via X-Curium-Org-Id header + DB lookup.
 */
export type IdentityClaims = {
    auth0UserId: string;
    email: string;
    oid?: string | null;
};

export type JwtClaims = {
    'https://curium.app/claims': IdentityClaims;
    iss: string;
    sub: string;
    aud: string[];
    iat: number;
    exp: number;
    scope: string;
    azp: string;
};

export function decodeJwtToken(token: string | undefined) {
    if (!token) {
        return undefined;
    }

    const [, base64Url] = token.split('.');
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map((item) => '%' + ('00' + item.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
    );

    return JSON.parse(jsonPayload) as JwtClaims;
}
